import {
  Box,
  Card,
  Stack,
  Text,
  Title,
  Button,
} from '@mantine/core';

function ErrorScreen({ message }) {
  const handleRetry = () => {
    window.location.reload();
  };

  return (
    <Box
      h="100vh"
      sx={{
        background: 'linear-gradient(135deg, #dc3545 0%, #6f42c1 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Card 
        shadow="xl" 
        p="3.75rem"
        radius="lg" 
        withBorder
        sx={{
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)',
          textAlign: 'center',
          maxWidth: '43.75rem'
        }}
      >
        <Stack align="center" gap="xl">
          <Text size="6rem" sx={{ lineHeight: 1 }}>⚠️</Text>
          <Title order={1} size="3rem" c="#dc3545">
            Connection Error
          </Title>
          <Text size="xl" c="#666" lh={1.4}>
            {message}
          </Text>
          <Button 
            color="green"
            size="xl"
            onClick={handleRetry}
            sx={{
              fontSize: '1.2rem',
              padding: '1rem 2.5rem',
              marginTop: '1.25rem'
            }}
          >
            🔄 Retry Connection
          </Button>
        </Stack>
      </Card>
    </Box>
  );
}

export default ErrorScreen;